module.exports = __webpack_public_path__ + "img/9-VenueInsights.8a710723.jpg";